import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, getFormValues, FormSection, SubmissionError, change, reset } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import ReactLoading from 'react-loading';
import Modal from 'react-responsive-modal';
import ArtistLoginForm from '../../components/ArtistLoginForm'
import agent from '../../agent'
import renderDatePicker from '../Datepicker';
import Countries from '../../data/countries';
import CountryStates from '../../data/states';
import _range from 'lodash/range'
import _debounce from 'lodash/debounce'
import { history } from '../../store/configureStore'
import SelectComponent from '../ui/SelectComponent'
import unions from '../../data/union-member-options';
import AMLogo from '../../assets/images/audition-magic-favicon.png';
import RadioGroupComponent from '../ui/RadioGroupComponent'

const renderField = ({ input, className, label, type, meta: { asyncValidating, touched, error, warning } }) => {
  if (touched && error) {
    return (
      <div className={className}>
      <div className="input-field">
        <label className="is-invalid-label">
          <input 
            {...input} 
            type={type}
            className="is-invalid-input" 
            placeholder={label} />
          <span className="form-error is-visible" id="uuid">{error}</span>
          { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
        </label>
      </div>
      </div>
    )
  }
  return (
    <div className={className}>
    <div className="input-field">
      <label>
        <input {...input} placeholder={label} type={type} />
        { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
      </label>
    </div>
    </div>
  )
}

const validate = {
  required: value => !value && "This field is required",
  radioval: value => !value && console.log("This field is required - hasUnion"),
  password: value => value.length >= 15 && "The field Password must be a string with a maximum length of 15.",
  email: value => !/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$$/.test(value) && "You have invalid email address"
} //"This field is required",

class General extends Component {

  state = {
    states: [],
    hasUnion: 'non-union',
    ageFromOptions: this.generateRange(0, this.props.artistInfo.is_minor ? 18 :101),
    ageToOptions: this.generateRange(this.props.artistInfo.age_from, this.props.artistInfo.is_minor ? 18 :101),
    countries: this.getCountries(),
    ageFrom: 0,
    ageTo: 0,
    ageCategory: this.props.artistInfo.is_minor ? 'minor' : 'adult'
  }

  componentWillMount() {
    const { artistInfo } = this.props.artistInfo
    //agency and talent profile
    console.log('componentWillMount', this.props)
    //this.props.artistInfo, this.props.initialValues
    //const country = artistInfo.artist ? artistInfo.artist.country : this.props.initialValues.artist.country;
    const country = this.props.initialValues.artist.country;

    const artist_storage = JSON.parse(window.localStorage.getItem('artist_jwt'))

    this.setState({
      states: this.props.initialValues.artist.country ?  //this.props.artistInfo.artist.country ? 
        CountryStates.filter(state => state.countryCode === (country || 'US') ) : [],
      artistInfo: artist_storage.artist ? artist_storage.artist : artistInfo
    })
  }

  componentWillReceiveProps (nextProps) {
    
  }

  submit = (values, dispatch, props) => {
    this.props.updateDetails(values.artist.id, values.artist).then((k) => {
      this.setState({ showModal_info: true })
    });
  }

  handleRadioChange(checkedvalue){
    console.log('radio-check: ' + checkedvalue);
  }

  getStates(value) {
    return this.filterStateByCountry(value)
    // return CountryStates.filter(states => states.countryCode === value || 'US')
  }

  getCountries() {
    return Countries.map(country => ({ value: country.code, label: country.name }) )
  }

  mapCountry(value) {
    return Countries.find(country => country.code == value).name || ""
  }
  
  resetBasicFields = (values) => {
    values.forEach(value => this.props.dispatch(change('artistRegistrationWizard', value, '')))
  }

  generateRange(start, end, step) {
      return _range(start, end, step).map(i => ({value: i, label: i}))
  }

  filterStateByCountry(country) {
    return CountryStates.filter(state => state.countryCode === (country || 'US') ) 
  }

  onChangeAgeFrom = (value, newValue) => {

    let upper_limit = (this.state.ageCategory === 'minor') ? 19 : 100

    this.setState({
      ageToOptions: _range(parseInt(newValue) + 1, upper_limit).map(i => ({value: i, label: i}))
    })
  }

  onChangeCountry = (value, countryCode ) => {
    this.setState({
      states: this.filterStateByCountry(countryCode)
    })
  }

  onCloseModal = () => {
    this.setState({ showModal_info: false });
  }

  getInitialValues () {
    const username = this.state.thisIsMeArtist ? this.state.thisIsMeArtist.email : ""
    return {
      username: username
    }
  }

  onChangeAgeCategory = (value) => {
    if (value === 'minor') {
      this.setState({
        ageFromOptions: _range(0, 18).map(i => ({value: i, label: i})),
        ageToOptions: _range(0, 18).map(i => ({value: i, label: i})),
        ageFrom: 0,
        ageTo: 17,
        ageCategory: 'minor'
      })
    }
    if (value === 'adult') {
      this.setState({
        ageFromOptions: _range(18, 101).map(i => ({value: i, label: i})),
        ageToOptions: _range(18, 101).map(i => ({value: i, label: i})),
        ageFrom: 18,
        ageTo: 100,
        ageCategory: 'adult'
      })
    }
  }

  render() {
    const { handleSubmit, submitting, pristine, artistType, disableButton, labels, moveToRepresentation } = this.props
    const { artistInfo } = this.state
    const unionList = unions.sort(function(a,b) { return a.name - b.name })
    const paddingFix = {
      paddingLeft: window.innerWidth < 700 ? '0.625rem' : '5rem'
    }
    const paddingP = {
      paddingRight: '1rem',
      marginTop: '0.5rem',
      color: 'rgba(255, 255, 255)'
    }
    const paddingCell = {
      paddingRight: '0.625rem',
      paddingLeft: '0.625rem'
    }
    return (
      <form onSubmit={handleSubmit} className="registartion-profile-form" id="reg-profile-form">
        
          <section id="section-profile" className="section gray-bg">
            <div className="grid-x align-center">
            <div className="small-12 medium-7 large-6 cell">
              <FormSection name="artist">

                <div className="grid-x align-center">
                  <div className="small-12 medium-7 grid-x align-center align-middle">
                    <p style={paddingP}>{labels.label}</p>
                    <div className="custom-checkbox">
                      <Field
                        className="styled-checkbox"
                        name="ageCategory"
                        id="minor"
                        value="minor"
                        component="input"
                        type="radio"
                        onChange={e => this.onChangeAgeCategory(e.target.value)}
                      />
                      <label htmlFor="minor">Minor &lt;18</label>
                    </div>
                    <div className="custom-checkbox">
                      <Field
                        className="styled-checkbox"
                        name="ageCategory"
                        id="adult"
                        value="adult"
                        component="input"
                        type="radio"
                        onChange={e => this.onChangeAgeCategory(e.target.value)}
                      />
                      <label htmlFor="adult">Adult 18+</label>
                    </div>
                  </div>
                </div>

                <div className="grid-x align-center">
                  <div className="small-12 medium-7 grid-y align-center align-middle">
                    <p className="edit-label">* Representation Type</p>
                    <p>
                      Representation can be set &nbsp;
                      <a onClick={moveToRepresentation}>here</a>
                    </p>
                    <br/><br/>
                  </div>
                </div>

                <div className="row">
                  <div className="small-12 medium-6 column">
                    <p className="edit-label">* First Name</p>
                    <Field
                      name="first_name"
                      type="text"
                      validate={[validate.required]}
                      component={renderField}
                      label="First Name" />
                  </div>
                  <div className="small-12 medium-6 column">
                    <p className="edit-label">* Last Name</p>
                    <Field
                      name="last_name"
                      type="text"
                      validate={[validate.required]}
                      component={renderField}
                      label="Last Name" />
                  </div>
                </div>

                <div className="row">
                  <div className="small-12 medium-6 column">
                    <p className="edit-label">* Contact Number</p>
                    <Field
                      name="mobile_number"
                      type="text"
                      component={renderField}
                      label="Contact Number" />
                  </div>
                  <div className="small-12 medium-6 column">
                    <p className="edit-label">* Email</p>
                    <Field
                      name="email"
                      type="email"
                      validate={[validate.email]}
                      component={renderField}
                      label="Email"/>
                  </div>
                </div>

                <div className="row">
                  <div className="small-12 medium-6 column">
                    <p className="edit-label">* Country</p>
                    <Field 
                        name="country" 
                        placeholder="Please select country"
                        component="select"
                        onChange={ this.onChangeCountry }>
                        {
                          this.state.countries.map((country, idx) => (
                            <option key={idx + 1}
                              value={country.value}>{country.label}</option>
                          ))
                        }
                    </Field>
                  </div>
                  {
                    this.state.states.length > 0 ?
                      <div className="small-12 medium-6 column">
                        <p className="edit-label">* State</p>
                        <Field 
                            name="state" 
                            placeholder="Please select state"
                            component="select">
                            {
                              this.state.states.map((state, idx) => (
                                <option key={idx + 1}
                                  value={state.id}>{state.name}</option>
                              ))
                            }
                        </Field>
                      </div> : <div></div>
                  }
                </div>

                <div className="row">
                  <div className="small-12 medium-6 column">
                    <p className="edit-label">* Gender</p>
                    <Field 
                      name="gender" 
                      component="select" 
                      placeholder="Select gender">
                        <option key='0' value='male'>Male</option>
                        <option key='1' value='female'>Female</option>
                        <option key='2' value='both'>Other (Non-binary)</option>
                        <option key='4' value=''>Undisclosed</option>
                    </Field>
                  </div>
                  <div className="small-12 medium-6 column">
                    <p className="edit-label">* Primary Talent Type</p>
                    <Field
                      name="category"
                      placeholder="Select primary talent type"
                      component="select">
                      {
                        artistType.map((type, idx) => (
                          <option key={idx + 1} 
                            value={type.value}>{type.label}</option> 
                        ))
                      }
                    </Field>
                  </div>
                </div>
                
                { (this.state.ageCategory === 'adult') &&
                  <div className="row">
                    <div className="small-12 medium-6 column">
                    <p className="edit-label">* My Playing Age (From)</p>
                    <Field
                      name="age_from"
                      placeholder="Select age from"
                      component="select"
                      value={this.state.ageFrom}
                      onChange={this.onChangeAgeFrom}>
                      {
                        this.state.ageFromOptions.map((age, idx) => (
                          <option key={idx + 1}
                            value={age.value}>{age.label}</option>
                        ))
                      }
                    </Field>
                    </div>

                    <div className="small-12 medium-6 column">
                      <p className="edit-label">* My Playing Age (To)</p>
                      <Field 
                        name="age_to"
                        placeholder="Select age to"
                        value={this.state.ageTo}
                        component="select">
                        {
                          this.state.ageToOptions.map((age, idx) => (
                            <option key={idx + 1}
                              value={age.value}>{age.label}</option>
                          ))
                        }
                      </Field>
                    </div>

                  </div>
                }

                { (this.state.ageCategory === 'minor') &&
                  <div className="row">
                    <p className="edit-label">&nbsp;&nbsp;&nbsp;&nbsp;* Birth Date</p>
                    <Field
                      className="small-12 medium-12 column"
                      name="birth_date"
                      component={renderDatePicker} />
                  </div>
                }

                <div className="row">
                  <div className="small-12 column">
                    <div className="custom-checkbox">
                      <Field
                        className="styled-checkbox"
                        name="hasUnion"
                        id="union"
                        value={"union"}
                        checked={this.state.hasUnion === 'union'}
                        onChange={(e) => this.setState({ hasUnion: e.target.value })}
                        component="input"
                        validate={[validate.radioval]}
                        type="radio"
                      />
                      <label htmlFor="union">Union</label>
                    </div>

                    <div className="custom-checkbox">
                      <Field
                        className="styled-checkbox"
                        name="hasUnion"
                        id="non-union"
                        value={"non-union"}
                        checked={this.state.hasUnion === 'non-union'}
                        onChange={(e) => this.setState({ hasUnion: e.target.value })}
                        validate={[validate.radioval]}
                        component="input"
                        type="radio"
                      />
                      <label htmlFor="non-union">Non Union</label>
                    </div>

                    {this.state.hasUnion === 'union' && (
                      <div>
                        <div className="row">
                          <div className="column medium-6">
                            <Field 
                              name="select_Union"
                              placeholder="Select Union"
                              component="select">
                              {
                                unionList.map((union, idx) => (
                                  <option key={idx + 1}
                                    value={union.id}>{union.name}</option>
                                ))
                              }
                            </Field>
                          </div>
                          <div className="column medium-6">
                            <Field
                              name="union_id"
                              type="text"
                              validate={[validate.required]}
                              component={renderField}
                              placeholder="Union ID" />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

              </FormSection>
            </div>
            </div>
          </section>    
          <section className="section">
            <div className="grid-x align-center">
              <div className="small-12 cell text-center">
                <button className="button primary" 
                  type="submit" 
                  disabled={pristine || submitting || disableButton}>
                    {submitting || disableButton ? 'Saving...' : 'Save' }
                </button>
              </div>
            </div>
          </section>
      </form>
    )
  }
}

General = reduxForm({
  form: 'artistProfile', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate,
  // asyncValidate,
  // asyncBlurFields: ['first_name', 'last_name', 'email']
})(General)

const selector = formValueSelector('artistProfile')
const mapStateToProps = state => ({
  // artistValues: state.common.artistInfo,
  // hasUnion: selector(state, 'artist[hasUnion]'),
  // hasCountry: selector(state, 'artist[country]'),
  // ...state.common,
  // ...state.auth,
  // ...state.artist,
  initialValues: {
    artist: {
      first_name: state.common.artistInfo ? state.common.artistInfo.first_name : '',
      last_name: state.common.artistInfo ? state.common.artistInfo.last_name : '',
      mobile_number: state.common.artistInfo ? state.common.artistInfo.mobile_number : '',
      artist_type: state.common.artistInfo ? state.common.artistInfo.artist_type : '',
      // at2_agency_name1: state.common.artistInfo.at2_agency_name,
      // at2_agency_name: state.common.artistInfo.at2_agency_name,
      email: state.common.artistInfo ? state.common.artistInfo.email : '',
      id: state.common.artistInfo ? state.common.artistInfo.id : '',
      gender: state.common.artistInfo ? state.common.artistInfo.gender : '',
      category: state.common.artistInfo ? state.common.artistInfo.category : '',
      age_from: state.common.artistInfo ? state.common.artistInfo.age_from : '',
      age_to: state.common.artistInfo ? state.common.artistInfo.age_to : '',
      birth_date: state.common.artistInfo ? state.common.artistInfo.birth_date : '',
      country: state.common.artistInfo ? state.common.artistInfo.country : '',
      state: state.common.artistInfo ? state.common.artistInfo.state : '',
      ageCategory: (state.common.artistInfo && state.common.artistInfo.is_minor) ? 'minor' : 'adult',
    }
  }
});

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset('artistProfile')),
  onUnload: () =>
    dispatch({ type: 'UNLOAD_PROFILE_FORM' }),
  resetSearch: () => 
    dispatch({ type: 'RESET_SEARCH' }),
  updateDetails: (id, artist) =>
    dispatch({type: 'UPDATE_ARTIST', payload: agent.Artist.updateDetails(id, artist) })
});

export default connect(mapStateToProps, mapDispatchToProps)(General);


// WEBPACK FOOTER //
// ./src/components/profile/General.js